import axios from './financeiroApi';

const contratoApi = () => {
  const getPath = () => {
    return '/api/v1/backend/contrato';
  };

  return {
    buscar: async (params) => {
      return axios.get(getPath(), { params });
    },

    buscarPorId: async (id, incluirHistorico = false) => {
      const url = `${getPath()}/${id}?incluirHistorico=${incluirHistorico}`;
      return axios.get(url);
    },

    buscarSomatorioFiltro: async (params) => {
      const url = `${getPath()}/somatorio`;
      return axios.get(url, { params });
    },

    excluir: async (params) => {
      return axios.delete(getPath(), { data: params });
    },

    cadastrar: async (contrato) => {
      const url = getPath();
      return axios.post(url, contrato);
    },

    atualizar: async (id, contrato) => {
      const url = `${getPath()}/${id}`;
      return axios.put(url, contrato);
    },

    rescindirContrato: async (rescisao, contratoId) => {
      const url = `${getPath()}/rescindir-contrato/${contratoId}`;
      return axios.put(url, rescisao);
    },

    uploadAnexo: async (anexo) => {
      return axios.post(`${getPath()}/anexo/upload`, anexo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    },

    downloadAnexo: async (anexoId) => {
      return axios({
        url: `${getPath()}/anexo/download/${anexoId}`,
        method: 'GET',
        responseType: 'blob',
      });
    },

    buscarPendenciasCobranca: (formaCobranca, clienteId) => {
      return axios.get(`${getPath()}/buscar-pendencias-cobranca?formaCobranca=${formaCobranca}&clienteId=${clienteId}`);
    },

    buscarContasReceberContrato: async (params) => {
      return axios.get(`${getPath()}/buscar-contas-receber-contrato`, { params });
    },

    buscarContratosIdsContaReceber: async (params) => {
      return axios.get(`${getPath()}/buscar-contratoIds-contas-receber`, { params });
    },

    resgatarContasReceberContrato: async (params, idNotificacao) => {
      return axios.put(`${getPath()}/resgatar-contas-receber-contrato?idNotificacao=${idNotificacao}`, params);
    },

    verificarPendenciasCobrancaContrato: async (params) => {
      return axios.get(`${getPath()}/pendencias-cobranca-contrato`, { params });
    },
  };
};

export { contratoApi };
